"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.base = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = require("@emotion/react");

var _util = require("../../util");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  0%{\n    transform:translateY(0px)\n  }\n  7%{\n    transform:translateY(", ")\n  }\n  11%{\n    transform:translateY(0px)\n }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  0%{\n    transform:translateY(0px)\n  }\n  28%{\n    transform:translateY(", ")\n  }\n  44%{\n    transform:translateY(0px)\n }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var shortAnimation = (0, _react.keyframes)(_templateObject(), (0, _util.rem)(-5));
var LongAnimation = (0, _react.keyframes)(_templateObject2(), (0, _util.rem)(-5));

var big = function big(theme) {
  return /*#__PURE__*/(0, _react.css)("font-size:", theme.fontSize.small, ";&>span{width:", (0, _util.rem)(16), ";line-height:", (0, _util.rem)(16), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:big;"));
};

var small = function small(theme) {
  return /*#__PURE__*/(0, _react.css)("font-size:", theme.fontSize.xtiny, ";&>span{width:", (0, _util.rem)(12), ";line-height:", (0, _util.rem)(12), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:small;"));
};

var newLabelSize = {
  big: big,
  small: small
};

var base = function base(_ref) {
  var theme = _ref.theme,
      isInfiniteAnimation = _ref.isInfiniteAnimation,
      size = _ref.size;
  return /*#__PURE__*/(0, _react.css)("font-weight:", theme.fontWeight.semibold, ";display:inline-flex;flex-wrap:nowrap;flex-shrink:0;z-index:1;position:relative;&>span{display:inline-block;background-color:", theme.color.brand['800'], ";color:", theme.color.monochrome.white, ";margin-right:1px;text-align:center;border-radius:", (0, _util.rem)(2), ";animation:", isInfiniteAnimation ? LongAnimation : shortAnimation, " ", isInfiniteAnimation ? 'infinite' : 2, " ease-in-out;animation-duration:", isInfiniteAnimation ? '6s' : '1.5s', ";&:first-of-type{animation-delay:0.2s;}&:nth-of-type(2){animation-delay:0.3s;}&:last-of-type{margin-right:0;animation-delay:0.4s;}}", newLabelSize[size](theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

exports.base = base;
var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=NewLabel.styles.js.map